import {
    LIST_FUNCTIONARIES,
    LIST_FUNCTIONARIES_SUCCESS,
    LIST_FUNCTIONARIES_ERROR,
    ADD_FUNCTIONARIES,
    SAVE_FUNCTIONARIES,
    SAVE_FUNCTIONARIES_SUCCESS,
    SAVE_FUNCTIONARIES_ERROR,
    EDIT_FUNCTIONARIES,
    ENABLE_FUNCTIONARIES,
    ENABLE_FUNCTIONARIES_SUCCESS,
    ENABLE_FUNCTIONARIES_ERROR,
    UPDATE_FUNCTIONARIES,
    UPDATE_FUNCTIONARIES_SUCCESS,
    UPDATE_FUNCTIONARIES_ERROR,
    DELETE_FUNCTIONARIES,
    DELETE_FUNCTIONARIES_SUCCESS,
    DELETE_FUNCTIONARIES_ERROR
} from '../types';

// Cada reducer tiene su propio state
const initialState = {    
    error: null,
    errorSave: null,
    functionaries: null,
    functionarySelected: null,
    isEdit: false,
    loading: false, 
    loadingSave: false
}


export default function(state = initialState, action) {
    switch(action.type){
        case LIST_FUNCTIONARIES:
            return {
                ...state,
                loading: true
            }
        case LIST_FUNCTIONARIES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_FUNCTIONARIES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                functionaries: action.payload
            }
        case ENABLE_FUNCTIONARIES:
        case SAVE_FUNCTIONARIES:
        case DELETE_FUNCTIONARIES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_FUNCTIONARIES:
            return {
                ...state,
                loadingSave: true
            }
        case ENABLE_FUNCTIONARIES_ERROR:
        case SAVE_FUNCTIONARIES_ERROR:
        case UPDATE_FUNCTIONARIES_ERROR:
        case DELETE_FUNCTIONARIES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_FUNCTIONARIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                functionaries: [...state.functionaries, action.payload]
            }
        case ADD_FUNCTIONARIES:
            return {
                ...state,
                functionarySelected: null,
                isEdit: false
            }
        case EDIT_FUNCTIONARIES:
            return {
                ...state,
                functionarySelected: action.payload,
                isEdit: true
            }
        case UPDATE_FUNCTIONARIES_SUCCESS:
        case DELETE_FUNCTIONARIES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                functionaries: state.functionaries.map(functionary => 
                    functionary.id === action.payload.id ? functionary = action.payload : functionary
                ),
                functionarieselected: null
            }
        case ENABLE_FUNCTIONARIES_SUCCESS:
            return {
                ...state,
                error: false,
                errorSave: false,
                functionaries: state.functionaries.map(functionary => 
                    functionary.id === action.payload.id ? functionary = action.payload : functionary
                ),
                isEdit: false,
                loading: false, 
                loadingSave: false
            }
        default:
            return state;
    }
}